<div class="container-fluid padT16">
  <div class="example-table-container">
    <table
      aria-describedby="table"
      mat-table
      matTableFilter
      [exampleEntity]="filterEntity"
      [filterType]="filterType"
      [dataSource]="dataSource"
      aria-describedby="mytabledesc"
      aria-describedby="mytabledesc"
    >
      <ng-container [matColumnDef]="column" *ngFor="let column of columnDefs; let i = index">
        <span *ngIf="column === 'checkbox'; else other">
          <th id="checkLabel" mat-header-cell class="customizetext" *matHeaderCellDef>
            <mat-checkbox
              class="custom-check"
              (change)="$event ? masterToggle($event) : null"
              [checked]="selection.hasValue() && isEntirePageSelected()"
              [aria-label]="checkboxLabel()"
              id="headercheckbox{{ i }}"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row; let j = index" class="customizetext">
            <mat-checkbox
              class="custom-check"
              (click)="$event.stopPropagation()"
              [checked]="selection.isSelected(row)"
              (change)="singleSelect($event, row)"
              [aria-label]="checkboxLabel(row)"
              id="columncheckbox{{ j }}"
            >
            </mat-checkbox>
          </td>
        </span>
        <ng-template #other>
          <span *ngIf="checkColumn(column)">
            <th id="displayColumnClick" class="customizetext" mat-header-cell *matHeaderCellDef>
              <div>{{ column }}</div>
              <div *ngIf="filterCheck(column)">
                <mat-form-field floatLabel="never">
                  <input
                    id="search-{{ column }}"
                    (blur)="filt()"
                    matInput
                    placeholder="Search"
                    [(ngModel)]="filterEntity[column]"
                    (paste)="rstrctSpclCharPaste($event, column)"
                    (keypress)="restrictSpclChar($event, column)"
                  />
                </mat-form-field>
              </div>
            </th>
            <td
              mat-cell
              id="{{ column }}{{ element[checkLabel] }}"
              class="customizetext"
              *matCellDef="let element"
              style="cursor: pointer"
              (click)="columnSelect(column, element[checkLabel], element)"
              [ngClass]="{ 'active-btn': column == checkLabel }"
            >
              <span>{{ element[column] }}</span>
            </td>
          </span>
          <span *ngIf="!checkColumn(column)">
            <th id="displayColumn" class="customizetext" mat-header-cell *matHeaderCellDef>
              <div>{{ column }}</div>
              <div *ngIf="filterCheck(column)">
                <mat-form-field floatLabel="never">
                  <input
                    id="search-{{ column }}"
                    (blur)="filt()"
                    matInput
                    placeholder="Search"
                    [(ngModel)]="filterEntity[column]"
                    (paste)="rstrctSpclCharPaste($event, column)"
                    (keypress)="restrictSpclChar($event, column)"
                  />
                </mat-form-field>
              </div>
            </th>
            <td mat-cell id="{{ column }}{{ element[checkLabel] }}" class="customizetext" *matCellDef="let element">
              <span>{{ element[column] }}</span>
            </td>
          </span>
        </ng-template>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnDefs; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnDefs"></tr>
    </table>
  </div>
  <div class="row paginatorPadding">
    <mat-paginator #matPagi showFirstLastButtons [pageSizeOptions]="[50]" [pageSize]="50"> </mat-paginator>
  </div>
</div>
